import React from 'react';
import ReactDOM from 'react-dom/client';

import { CartProvider } from '../../contexts/CartContext';
import AthleteShop from './pages/AthleteShop';
import './index.css';
import './athlete-shop.css';

function initShopComponent() {
    const shopRoot = document.getElementById('shop-root');
    const shopDataEl = document.getElementById('shopData');
    if (!shopRoot || !shopDataEl) { return; }

    const shopData = JSON.parse(shopDataEl.textContent || '{}');
    const root = ReactDOM.createRoot(shopRoot);
    root.render(
        React.createElement(
            CartProvider,
            { csrfToken: shopData.csrfToken || undefined },
            React.createElement(AthleteShop, {
                csrfToken: shopData.csrfToken || '',
                athleteInfo: shopData.athleteInfo,
                brands: shopData.brands || [],
                capsules: shopData.capsules || [],
                products: shopData.products || [],
                socials: shopData.socials || [],
                splashRedesignEnabled: shopData.splashRedesignEnabled === true,
            }),
        ),
    );
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopComponent);
} else {
    initShopComponent();
}

if (module.hot) { module.hot.accept(); }
